import script from "./RenewReg.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewReg.vue?vue&type=script&setup=true&lang=js"

import "./RenewReg.vue?vue&type=style&index=0&id=821dc6fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-821dc6fa"]])

export default __exports__